export const AED = 'AED';
export const INCOMING_ASSIGNMENT = 'INCOMING_ASSIGNMENT';
